import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Minus, Plus, RefreshCw } from "lucide-react";

const LABELS = { serum: "Sérum", variant: "Variante", coffret: "Coffret" };
const UNIVERSES = { all: "Tous", femme: "Femme", homme: "Homme", mixte: "Mixte" };

export function AdminStockPanel() {
  const [products, setProducts] = useState([]);
  const [busy, setBusy] = useState({});
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/products"); setProducts(data || []); }
    catch { toast.error("Impossible de charger les stocks"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const save = async (p, stock) => {
    const value = Math.max(0, Number(stock) || 0);
    setBusy((b) => ({ ...b, [p.id]: true }));
    try {
      const { data } = await api.put(`/admin/products/${p.id}`, { stock: value });
      setProducts((list) => list.map((x) => x.id === p.id ? data : x));
      toast.success(`${p.name} : stock ${value}`);
    } catch { toast.error("Erreur de mise à jour du stock"); }
    finally { setBusy((b) => ({ ...b, [p.id]: false })); }
  };

  const setStock = (id, value) => setProducts((list) => list.map((x) => x.id === id ? { ...x, stock: Math.max(0, Number(value) || 0) } : x));
  const out = (p) => Number(p.stock || 0) <= 0;

  return (
    <div className="space-y-5" data-testid="admin-stock-panel">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="overline mb-1">Gestion des stocks</p>
          <p className="text-sm" style={{ color: "var(--lo-muted)" }}>Modifie ici le stock réel de chaque article. À 0, l'article devient automatiquement « Épuisé » et ne peut plus être commandé.</p>
        </div>
        <button onClick={load} className="btn-ghost inline-flex items-center gap-2 h-10 px-4" disabled={loading}><RefreshCw size={14} /> Actualiser</button>
      </div>

      {loading ? <p className="text-sm" style={{ color: "var(--lo-muted)" }}>Chargement…</p> : (
        <div className="grid gap-3">
          {products.map((p) => {
            const current = Number(p.stock || 0);
            return (
              <div key={p.id} className="card-lux p-4" data-testid={`stock-row-${p.slug}`}>
                <div className="flex items-center gap-4">
                  {p.image && <img src={p.image} alt="" className="w-16 h-16 object-cover shrink-0" style={{ border: "1px solid var(--lo-border)" }} />}
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <span className="badge-save text-[9px] px-2 py-0.5 uppercase">{LABELS[p.category] || p.category}</span>
                      <span className="overline text-[9px]">{UNIVERSES[p.universe] || p.universe}</span>
                      {out(p) ? <span className="text-[9px] uppercase tracking-wider px-2 py-1" style={{ background: "#3a2a2a", color: "#e8b4b4" }}>Épuisé</span> : <span className="text-[9px] uppercase tracking-wider" style={{ color: "var(--lo-rose-hi)" }}>Disponible</span>}
                    </div>
                    <p className="font-display text-lg truncate">{p.name}</p>
                    <p className="text-xs" style={{ color: "var(--lo-muted)" }}>{p.lookup_key}</p>
                  </div>
                  <div className="flex items-center gap-2 shrink-0">
                    <button className="w-9 h-9 border flex items-center justify-center disabled:opacity-30" disabled={current <= 0 || busy[p.id]} onClick={() => setStock(p.id, current - 1)}><Minus size={14} /></button>
                    <input type="number" min="0" value={current} onChange={(e) => setStock(p.id, e.target.value)} className="w-20 h-9 bg-transparent border text-center outline-none" style={{ borderColor: "var(--lo-border-rose)" }} data-testid={`stock-input-${p.slug}`} />
                    <button className="w-9 h-9 border flex items-center justify-center disabled:opacity-30" disabled={busy[p.id]} onClick={() => setStock(p.id, current + 1)}><Plus size={14} /></button>
                    <button className="btn-primary h-9 px-4 text-xs disabled:opacity-50" disabled={busy[p.id]} onClick={() => save(p, current)} data-testid={`stock-save-${p.slug}`}>{busy[p.id] ? "…" : "Enregistrer"}</button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
